"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.findNestedObjectValue = void 0;
const isObject = (value) => !!(value && typeof value === 'object' && !Array.isArray(value));
const findNestedObjectValue = (object, keyToMatch) => {
    if (!isObject(object))
        return undefined;
    const entries = Object.entries(object);
    for (const [objectKey, objectValue] of entries) {
        // eslint-disable-next-line no-prototype-builtins
        const hasProperty = object.hasOwnProperty(objectKey);
        const keyMatching = objectKey === keyToMatch;
        if (hasProperty && keyMatching) {
            return objectValue;
        }
        else {
            const child = (0, exports.findNestedObjectValue)(objectValue, keyToMatch);
            if (child !== undefined)
                return child;
        }
    }
};
exports.findNestedObjectValue = findNestedObjectValue;
//# sourceMappingURL=findNestedObjectValue.js.map